module.exports = __webpack_public_path__ + "img/pie-chart2.02e95b65.svg";